import * as Sentry from "@sentry/react";

/**
 * Initialise GlitchTip crash + error reporting for the OneVision dashboard SPA.
 * (T39 P0 #2 — R29–R34: every OneVision surface reports to GlitchTip.)
 *
 * The DSN is injected at build time via REACT_APP_SENTRY_DSN and is NEVER
 * committed (R8 / R30) — paste it as the build env for the `onevision-dashboard-*`
 * GlitchTip project. When it is unset (local dev, or a lab build without a DSN)
 * this is a deliberate silent no-op: nothing breaks and no events are sent.
 *
 * Forward-compatible config only — `init({ dsn, environment, release, ... })` is
 * stable across @sentry/react v7→v10, so a later SDK bump (when this app is
 * modernised off CRA) needs no change here.
 */
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;

  if (!dsn) {
    // eslint-disable-next-line no-console
    console.info("[sentry] crash reporting disabled — REACT_APP_SENTRY_DSN not set");
    return;
  }

  Sentry.init({
    dsn,
    // prod | staging | dev — drives GlitchTip environment filtering (R30).
    environment: process.env.REACT_APP_SENTRY_ENV || "production",
    // Git SHA at build time so a crash correlates back to a commit (R30).
    release:
      process.env.REACT_APP_GIT_SHA ||
      process.env.REACT_APP_BUILD_ID ||
      "onevision-dashboard@dev",
    // Never ship PII to GlitchTip (R8). After login the app may identify the
    // user with an anonymised hash via Sentry.setUser({ id: <hash> }).
    sendDefaultPii: false,
    // High-volume browser noise that is never actionable.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
      "Non-Error promise rejection captured",
    ],
  });
}
